import { useEffect, useState } from 'react';
import { Contribution } from 'types/contribution';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getContributionHref } from 'app/store/SongList/selectors';
import { fetchContributionEffect } from 'app/store/SongList/effects';
import { fetchCountriesEffect } from 'app/store/Countries/effects';
import { useResource } from 'app/utils/hooks';
import { getCountries } from 'app/store/Countries/selectors';
import { ContributionForm } from '../ContributionForm';
import { ContributionFormLoader } from '../ContributionForm/ContributionFormLoader';

interface EditContributionProps {
  contributionGuid: string;
  onClose: () => void;
}

export const EditContribution = ({
  contributionGuid,
  onClose,
}: EditContributionProps) => {
  const dispatch = useAppDispatch();
  const fetchContributionLink = useAppSelector(getContributionHref);
  const [countries] = useResource(fetchCountriesEffect, getCountries);
  const [contribution, setContribution] = useState<Contribution | null>(null);

  const fetchContribution = async () => {
    const contribution = await dispatch(
      fetchContributionEffect({ guid: contributionGuid as string })
    ).unwrap();
    setContribution(contribution);
  };

  useEffect(() => {
    fetchContribution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchContributionLink]);

  return countries && contribution ? (
    <ContributionForm
      contribution={contribution}
      countries={countries}
      onClose={onClose}
    />
  ) : (
    <ContributionFormLoader full />
  );
};
